(function () {
    'use strict';

    angular.module('mgpCorregedoriaApp').controller('AccordionMenu', AccordionMenu);

    function AccordionMenu($scope) {
        $scope.oneAtATime = true;
        $scope.status = {
            isFirstOpen: false,
            isSecondOpen: false,
            isThirdOpen: false,
            isFourthOpen: false,
            isFifthOpen: false,
            isSixOpen: false
        };
    }
})();
